<template>
  <div :class="$style['pt-lab-product-form']">
    <pt-sub-title title="检测项目信息"></pt-sub-title>
    <!-- <pt-form-list-item label="检测项目编号：" :required="true">
      <el-input data-vv-as="检测项目编号" v-validate="'required'" v-model="currentData.itemVersion" placeholder="请填写检测项目编号"></el-input>
    </pt-form-list-item> -->
    <pt-form-list-item label="检测项目名称：" :required="true">
      <el-input data-vv-as="检测项目名称" v-validate="'required'" v-model="currentData.itemName" placeholder="请填写检测项目名称"></el-input>
    </pt-form-list-item>
    <pt-form-list-item label="检测依据：" :required="true">
      <method-selector data-vv-as="检测依据" v-validate="'required'" v-model="currentData.examBasis" placeholder="请选择"></method-selector>
    </pt-form-list-item>
    <pt-form-list-item label="检测依据相关文件：">
      <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text" v-model="currentData.attachments">
        <el-button size="small" type="primary">点击上传</el-button>
      </wt-upload-file>
    </pt-form-list-item>
    <!-- <pt-form-list-item label="检测依据：" :required="true">
      <el-input data-vv-as="检测依据" v-validate="'required'" v-model="currentData.examBasis" placeholder="请填写检测依据"></el-input>
    </pt-form-list-item> -->
    <pt-form-list-item label="检测周期：">
      <el-input data-vv-as="检测周期" v-model="currentData.testCycle" placeholder="请填写产品检测周期">
      </el-input>
      <el-radio-group style="margin-left:10px" data-vv-as="时间类型" v-validate="'required'" v-model="currentData.dayType">
        <el-radio label="WORK_DAY">工作日</el-radio>', '
        <el-radio label="NATURAL_DAY">自然日</el-radio>
      </el-radio-group>
    </pt-form-list-item>
  </div>
</template>

<script>
import formMixins from 'mixins/form'
import methodSelector from 'cps/selector/method-selector'
// 组件class前缀
const prefixCls = 'pt-lab-product-form'

export default {
  name: 'pt-lab-product-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  components: {
    methodSelector
  },
  props: {
    value: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      labelWidth: '100px',
      currentData: this.value,
      selectMaterials_info: [],
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'lab_exam_item',
        objectId: this.value.id || 0
      },
      privateResourcesUrl: this.$privateResourcesUrl
    }
  },
  watch: {
    value (val) {
      this.currentData = val
			this.currentData.attachments=this.currentData.attachments||[]
    }
  },
  methods: {

  }
}

</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-lab-product-form {
  :global {
    .el-input,
    .el-input__inner {
      max-width: 2.8rem;
    }

    .el-input--suffix .el-input__inner {
      min-width: 2.8rem;
    }

    .el-upload--picture-card,
    .el-upload-list--picture-card .el-upload-list__item {
      width: 117px;
      height: 155px;
    }

    el-textarea,
    .el-textarea__inner {
      width: 500px;
      font-family: "Microsoft YaHei", "微软雅黑", "Avenir", Helvetica, Arial;
    }

    .wt-upload-file {
      line-height: 0;
      margin-top: 10px;
    }
  }

  .upload-file-text {
    line-height: 155px;
  }
}
.specification-table-div {
  margin: 20px 0;
  padding: 30px 50px;
}

.specification-table {
  display: table !important;
  width: 100%;
  border-collapse: collapse !important;
  th,
  tr {
    width: 100% !important;
    max-width: 100% !important;
    display: table-row;
    padding: 0 !important;
    list-style-type: none;
    border-bottom: 1px solid #c6c9d3;
    color: #818181;
  }
  td {
    text-align: left;
    padding: 10px;
  }
  :global .td_input .el-input--suffix .el-input__inner {
    min-width: 0.8rem !important;
  }
  :global .td_select .el-input--suffix .el-input__inner {
    min-width: 1.2rem !important;
  }
}
</style>
